import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/* eslint-disable react/prop-types */
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { FaCircle } from 'react-icons/fa';
import { useRadioButtonGroupState } from '../RadioButtonGroup';
import CheckboxRadioBase from '../CheckboxRadioBase';
import withThemeProps from '../withThemeProps';
var RadioButtonBase = styled(CheckboxRadioBase).withConfig({
  displayName: "RadioButton__RadioButtonBase",
  componentId: "sc-1k404zr-0"
})(["\n  border-radius: 50%;\n  padding: 3px;\n  font-size: 8px;\n"]);
/**
 * Radio button input with custom rendering.
 */

export var RadioButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var _ref$checkmarkIcon = _ref.checkmarkIcon,
      checkmarkIcon = _ref$checkmarkIcon === void 0 ? FaCircle : _ref$checkmarkIcon,
      name = _ref.name,
      onChange = _ref.onChange,
      value = _ref.value,
      rest = _objectWithoutProperties(_ref, ["checkmarkIcon", "name", "onChange", "value"]);

  var radioButtonGroupState = useRadioButtonGroupState(); // Only defined for radio buttons inside radio button groups!

  var isChecked;
  var groupOnChange;

  if (radioButtonGroupState) {
    name = name || radioButtonGroupState.name;
    isChecked = radioButtonGroupState.value === value;
    groupOnChange = radioButtonGroupState.onChange;
  }

  var handleChange = useCallback(function (event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (onChange) {
      onChange(event, ...args);
    }

    if (groupOnChange) {
      groupOnChange(event, ...args);
    }
  }, [onChange, groupOnChange]);
  return /*#__PURE__*/React.createElement(RadioButtonBase, _extends({
    type: "radio",
    checkmarkIcon: checkmarkIcon,
    name: name,
    value: value,
    checked: isChecked,
    onChange: handleChange,
    ref: ref
  }, rest));
});
RadioButton.displayName = 'RadioButton';
export default withThemeProps(RadioButton, {
  section: 'radioButton',
  defaultVariant: 'default'
});